import {
  UPDATE_GAME_VERIFY_LOADING,
  UPDATE_GAME_VERIFY_PHONE,
  UPDATE_GAME_VERIFY_REQUEST,
  UPDATE_GAME_VERIFY_REQUEST_FORM
} from "../actions/types"

const initialState = {
  loading: false,
  phone: null,
  requestSaveData: {
    otp: "",
    errorMessage: "",
    status: 0,
    referenceCode: "",
    statusAPIValidate: 0,
    verifyType: "phone"
  },
  otpData: {
    otpId: "",
    otcId: "f5b25de5-619f-40bc-a216-e2cd48ec5590",
    result: null,
    errorCount: true,
    exprCode: true
  }
}

const gameVerify = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case UPDATE_GAME_VERIFY_LOADING:
      return {
        ...state,
        loading: payload
      }
    case UPDATE_GAME_VERIFY_PHONE:
      return {
        ...state,
        phone: payload
      }
    case UPDATE_GAME_VERIFY_REQUEST:
      return {
        ...state,
        requestSaveData: {
          ...state.requestSaveData,
          [payload.name]: payload.value
        }
      }
    case UPDATE_GAME_VERIFY_REQUEST_FORM:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          otpId: payload.otpId,
          result: payload.result,
          errorCount: payload.errorCount,
          exprCode: payload.exprCode
        }
      }
    default:
      return state
  }
}

export default gameVerify